import { CheckboxOption } from '@common/components/CheckboxOption/CheckboxOption';
import { getNewSubmissionReasons, getUpdateSubmissionReasons } from '@common/features/reasons/submissionReasons';
import * as Styled from './styles';
import { ContentDetailsFormField } from '../../pages/ContentDetails/types';
import { DocumentType, ICheckboxEntry } from '@common/types';
import { ISubmissionReasonDto } from '@common/features/submission/types';
import { RichTextEditor } from '@common/components/RichTextEditor/RichTextEditor';


interface IReadonlySubmissionDetails {
  contentType: DocumentType;
  version: number;
  reasonsForSubmission: ISubmissionReasonDto[];
  details: string;
}

export const ReadonlySubmissionDetails = ({
  contentType,
  version,
  reasonsForSubmission,
  details,
}: IReadonlySubmissionDetails) => {
  const isItemSelected = (item: ICheckboxEntry) => {
    return !!reasonsForSubmission.find((reason) => reason.id === item.id);
  };

  const toolbarOptions = [[{ header: [1, 2, 3, 4, false] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']];

  const renderDetails = () => {
    var reasons = version === 1 ? getNewSubmissionReasons(contentType) : getUpdateSubmissionReasons(contentType);
    return reasons.map((item, index) => {
      const isSelected = isItemSelected(item);
      return (
        <CheckboxOption
          data-testid={`reason-checkbox-${index}`}
          key={item.id}
          name={`submission detail ${item.id}`}
          item={item}
          onChange={() => {}}
          isChecked={isSelected}
          disabled
        />
      );
    });
  };

  return (
    <Styled.SubmissionDetailsWrap>
      <Styled.SubmissionReasonsWrap>
        <Styled.SectionLabel>Reasons for submission</Styled.SectionLabel>
        <Styled.SubmissionReasonsContent>{renderDetails()}</Styled.SubmissionReasonsContent>
      </Styled.SubmissionReasonsWrap>
      <Styled.SubmissionNotesWrap>
      <Styled.SectionLabel>Submission notes</Styled.SectionLabel>
        <Styled.SubmissionNotesContent>
          <RichTextEditor
            fieldName={ContentDetailsFormField.details}
            toolbarOptions={toolbarOptions}
            value={details}
            className="addModalEditorWrapper"
            placeholder="Notes here (eg. Section 1 update)"
            readOnly={true}
          />
        </Styled.SubmissionNotesContent>
      </Styled.SubmissionNotesWrap>
    </Styled.SubmissionDetailsWrap>
  );
};
